const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;

export default {
     users : `${API_DOMAIN}/rest/api/user`,
     status : `${API_DOMAIN}/rest/api/status`,
     resetLink : `${API_DOMAIN}/rest/api/resetlink/`,
     audit : `${API_DOMAIN}/rest/api/audit/`,
     login : `${API_DOMAIN}/rest/api/login`
}
